var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:( _obj = { 'dynamic-height': _vm.dynamicHeight, 'banner': true}, _obj[_vm.colorVariant] = true, _obj ),on:{"click":_vm.onBannerClicked}},[_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }